import { render, staticRenderFns } from "./SkillGame.html?vue&type=template&id=1f39bcd1&scoped=true&"
import script from "./SkillGame.vue?vue&type=script&lang=js&"
export * from "./SkillGame.vue?vue&type=script&lang=js&"
import style0 from "./SkillGame.scss?vue&type=style&index=0&id=1f39bcd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f39bcd1",
  null
  
)

export default component.exports